// Shared state management for chat to prevent iframe reloads during chat requests
const CHAT_IN_PROGRESS_KEY = 'chat_request_in_progress';

export const setChatInProgress = (inProgress) => {
  if (inProgress) {
    localStorage.setItem(CHAT_IN_PROGRESS_KEY, 'true');
  } else {
    localStorage.removeItem(CHAT_IN_PROGRESS_KEY);
  }
};

export const isChatInProgress = () => {
  return localStorage.getItem(CHAT_IN_PROGRESS_KEY) === 'true';
};
